import { EJsonQueryPriceType } from '@cian/api-models/common/json_query';
import { IControlOption } from '@cian/ui-kit/types/controls/IControlGroupProps';

export class CoworkingSwitchButtonModel implements IControlOption<EJsonQueryPriceType | 'all'> {
  public readonly label: string;

  public readonly value: EJsonQueryPriceType | 'all';

  public constructor(label: CoworkingSwitchButtonModel['label'], value: CoworkingSwitchButtonModel['value']) {
    this.label = label;

    this.value = value;
  }
}
